"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHeartFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12 20.994c-.322-.003-.708-.158-1.158-.465C6.652 17.375 2 14.46 2 8.995 2 5.627 4.42 3 7.5 3c1.74 0 3.41.883 4.5 2.267C13.09 3.883 14.76 3 16.5 3 19.58 3 22 5.627 22 8.995c0 5.523-4.862 8.495-8.854 11.534-.442.314-.824.47-1.146.465z' }))); };
exports.default = SvgHeartFilled;
//# sourceMappingURL=HeartFilled.js.map